import React, { useEffect,useState } from "react";

import { IntlProvider } from "react-intl";

/**
 * Gets messages for the specified locale.
 */
const getMessages = async (locale) => {
  const localeFileName = locale.toLowerCase();
  try {
    const messages = await import(
      `@skillshare/ui-components/locales/dist/${localeFileName}.json`
    );
    return messages;
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
  }
};
// eslint-disable-next-line react/prop-types
export const ReactBoneIntlProvider = ({ forceLocale, children }) => {
  let locale = forceLocale ? forceLocale : window.SS.serverBootstrap.siteLocale;
 
  const [messages, setMessages] = useState(null);

  useEffect(() => {
    (async () => {
      const messages = await getMessages(locale.toLowerCase());
      setMessages(messages);
    })();
  }, [locale]);
  return (
    <IntlProvider locale={locale} defaultLocale="en" messages={messages}>
      {children}
    </IntlProvider>
  );
};
